// src/games/wintermere/scenes.js
export const scenes = {
    intro: {
      id: "intro_01",
      title: "The Frozen Gates",
      description: `The bitter wind howls around you as you stand before the frost-covered ruins of Castle Wintermere. 
      Ancient stones loom against the steel-grey sky, their surfaces etched with ice and shadow. The once-proud 
      fortress now stands as a silent testament to forgotten glory—and untold dangers.`,
      choices: [
        {
          id: "intro_choice_1",
          text: "Enter through the main gate",
          requires: null,
          nextScene: "courtyard_01",
          consequences: {
            experience: 25,
            storyFlags: ["used_main_entrance"]
          }
        },
        {
          id: "intro_choice_2",
          text: "Search for a side entrance",
          requires: null,
          nextScene: "servants_passage_01",
          consequences: {
            experience: 50,
            storyFlags: ["found_secret_entrance"]
          }
        },
        {
          id: "intro_choice_3",
          text: "Examine the castle walls",
          requires: null,
          nextScene: "castle_walls_01",
          consequences: {
            experience: 35,
            storyFlags: ["examined_walls"]
          }
        }
      ]
    },
    // Add more scenes here
  };